(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-campaign-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('me-campaign-film')) {
  customElements.define('me-campaign-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button || this.abort) return;
      this.abort = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motion.matches;
      this.inView = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.controls = false;
      this.button.hidden = false;
      const signal = this.abort.signal;
      const sync = () => {
        const label = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.button.textContent = label;
        this.button.setAttribute('aria-label', label);
      };
      const play = () => {
        if (this.userPaused || document.hidden || !this.inView) return;
        const request = this.video.play();
        if (request) request.catch(sync);
      };
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.inView = true;
          play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, { signal });
      this.video.addEventListener('play', sync, { signal });
      this.video.addEventListener('pause', sync, { signal });
      this.video.addEventListener('error', sync, { signal });
      this.video.addEventListener('loadeddata', play, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else play();
      }, { signal });
      this.motion.addEventListener('change', event => {
        this.userPaused = event.matches;
        if (event.matches) this.video.pause();
        else play();
      }, { signal });
      if (this.userPaused) {
        this.video.autoplay = false;
        this.video.pause();
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
            if (this.inView) play();
            else this.video.pause();
          }
        }, { threshold: [0, 0.15] });
        this.observer.observe(this.video);
      } else {
        this.inView = true;
        play();
      }
      sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
      this.video?.pause();
    }
  });
}


(function () {
  const STORY_METRIC = 'ME — Histoire partagée';
  const KLAVIYO_COMPANY_ID = 'S6n3fE';

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('.me-story-form');
    if (!form || !form.checkValidity()) return;

    const email = form.querySelector('[name="contact[email]"]')?.value?.trim();
    const firstName = form.querySelector('[name="contact[Prénom]"]')?.value?.trim();
    if (!email) return;

    const saidAboutMe = form.querySelector('[name="contact[Ce qu’on disait de moi]"]')?.value?.trim() || '';
    const whatIDid = form.querySelector('[name="contact[Ce que j’en ai fait]"]')?.value?.trim() || '';
    const instagram = form.querySelector('[name="contact[Instagram]"]')?.value?.trim() || '';
    const consent = form.querySelector('[name="contact[Autorisation de partage]"]')?.checked === true;

    const payload = {
      data: {
        type: 'event',
        attributes: {
          metric: {
            data: {
              type: 'metric',
              attributes: { name: STORY_METRIC }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName || undefined
              }
            }
          },
          properties: {
            source: 'shopify_story_form',
            'Ce qu’on disait de moi': saidAboutMe,
            'Ce que j’en ai fait': whatIDid,
            Instagram: instagram,
            'Autorisation de partage': consent ? 'Oui' : 'Non'
          },
          unique_id: 'story-' + Date.now() + '-' + Math.random().toString(36).slice(2)
        }
      }
    };

    fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID), {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json',
        'revision': '2026-07-15'
      },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function () {});
  }, true);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-product-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-me-size-guide]');
  if (!link) return;
  const guide = document.getElementById(link.getAttribute('href').slice(1));
  if (!guide) return;
  event.preventDefault();
  guide.open = true;
  guide.querySelector('summary').focus({preventScroll:true});
  guide.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
});

  } catch(e) { console.error(e); }
})();
})();
